<template>
  <div
    :id="uniqueId"
    :class="{ 'is-active': showDropdown }"
    class="dropdown"
  >
    <div class="dropdown-trigger">
      <button
        class="button"
        aria-haspopup="true"
        :aria-controls="uniqueId"
        @click="showDropdown = true"
      >
        <template v-if="!isMobile">
          <span>{{ label }}</span>
        </template>
        <span class="icon is-small">
          <i
            :class="icon"
            aria-hidden="true"
          />
        </span>
      </button>
    </div>

    <div
      class="dropdown-menu"
      role="menu"
    >
      <div class="dropdown-content">
        <div class="dropdown-item is-title">
          <span>{{ config.title }}</span>
          <button
            class="button is-small ml-auto"
            @click="showDropdown = false"
          >
            <span>Fechar</span>
            <span class="icon is-small">
              <i
                class="fas fa-times"
                aria-hidden="true"
              />
            </span>
          </button>
        </div>

        <div class="dropdown-divider" />

        <ul class="dropdown-item">
          <li class="text mb-2">
            <span v-html="config.text" />
          </li>
          <li
            v-for="(option, index) in config.options"
            :key="index"
            class="option"
          >
            <p
              class="is-title"
              v-html="option.title"
            />
            <p v-html="option.text" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    icon: {
      type: String,
      default: '',
      required: true,
    },
    config: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  data: () => ({
    uniqueId: `base-dropmenu-${Math.random().toString(36).substr(2, 9)}`,
    showDropdown: false,
  }),
  computed: {
    ...mapGetters({
      isMobile: 'app/isMobile',
    }),
    selectedOption() {
      return this.options.find((option) => option.value === this.modelValue) || {};
    },
  },
  watch: {
    showDropdown(isTrue) {
      if (isTrue) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
  },
  methods: {
    handleClickOutside({ target }) {
      const element = target.closest(`#${this.uniqueId}`);
      if (!element || !element.contains(target)) {
        this.showDropdown = false;
      }
    },
    // ...
  },
};
</script>

<style lang="scss" scoped>
.button {
  border-radius: 8px !important;
}

.dropdown {
  &-trigger {
    .button {
      border: none;
      background-color: #374178;

      font: {
        family: Inter;
        size: 14px;
        weight: 400;
      }
      line-height: 32px;
      color: #fff;

      .icon {
        color: #fff;
      }
    }
  }

  &-menu {
    $top: 75px;

    position: fixed;
    top: $top;
    left: 50%;

    width: fit-content;
    padding: 0;

    transform: translate(-50%, #{$top});

    @media (min-width: 768px) {
      position: absolute;
      top: calc(100% + 5px);
      left: initial;
      bottom: initial;
      right: 0;

      transform: none;
    }
  }

  &-content {
    border-radius: 8px;
    background-color: #fff;
  }

  &-divider {
    border-top: 1px solid #E5E7EB;
  }

  &-item {
    width: 300px;

    font: {
      family: Inter;
      size: 14px;
      weight: 400;
    }
    line-height: 16px;

    color: #6B7280;
    white-space: initial;

    @media (min-width: 768px) {
      width: 460px;
    }
  }

  .is-title {
    display: flex;
    column-gap: 1rem;

    align-items: center;

    font: {
      family: Inter;
      weight: 600;
    }
    line-height: 16px;
    color: #333;
    white-space: nowrap;
  }

  .text {
    font: {
      family: Inter;
      size: 14px;
      weight: 400;
    }
    line-height: 16px;
    color: #1A1A1A;
  }

  counter-reset: option;

  ul {
    li {
      $size: 2rem;

      display: grid;
      padding: 0.5rem 0;

      grid-template-areas: 'number title' 'number text';
      align-items: center;

      &:not(.text)::before {
        counter-increment: option;
        content: counter(option);

        grid-area: number;

        margin-right: 1rem;

        display: flex;
        width: $size;
        height: $size;
        background-color: $blue-900;
        border-radius: $size;

        align-items: center;
        justify-content: center;

        font: {
          family: Inter;
          size: 14px;
          weight: 700;
        }
        line-height: 14px;
        color: $prata-green-300;
      }

      .is-title {
        grid-area: title;
        margin-bottom: 0.25rem;
      }

      p:nth-child(2) {
        grid-area: text;
      }
    }
  }
}
</style>
